export default () => {
    return window.location.search.indexOf('dev=true') > 0;
};
